// Extracted from web/components/ModelCanvas.tsx; behavior and declaration bodies preserved.
import type { Notation, Point, Side } from "../../shared/contracts.js";

import { normal } from "../components/canvasGeometry.js";
export function EndpointMark({
  point,
  side,
  many,
  optional,
  notation,
  identifying,
}: {
  point: Point;
  side: Side;
  many: boolean;
  optional: boolean;
  notation: Notation;
  identifying: boolean;
}) {
  const n = normal(side),
    angle = (Math.atan2(n.y, n.x) * 180) / Math.PI;
  if (notation === "uml" || notation === "chen")
    return (
      <text
        x={point.x + n.x * 19 + (n.y ? 9 : 0)}
        y={point.y + n.y * 19 - (n.x ? 7 : 0)}
        className="dg-canvas-multiplicity"
        textAnchor={n.x < 0 ? "end" : "start"}
      >
        {notation === "uml"
          ? `${optional ? "0" : "1"}..${many ? "*" : "1"}`
          : many
            ? "N"
            : "1"}
      </text>
    );
  if (notation === "idef1x")
    return (
      <g
        transform={`translate(${point.x} ${point.y}) rotate(${angle})`}
        className="dg-canvas-endmark"
      >
        {many ? (
          <circle cx={8} cy={0} r={4} fill="currentColor" />
        ) : (
          <path d="M 8 -5 L 8 5" />
        )}
        {optional && (
          <path
            d="M 17 0 L 22 -4 L 27 0 L 22 4 Z"
            fill="var(--canvas, #f5f7f8)"
          />
        )}
        {identifying && !many && <path d="M 13 -5 L 13 5" />}
      </g>
    );
  return (
    <g
      transform={`translate(${point.x} ${point.y}) rotate(${angle})`}
      className="dg-canvas-endmark"
    >
      {many ? (
        <path d="M 1 -6 L 13 0 L 1 6 M 1 0 L 13 0" />
      ) : (
        <path d="M 8 -6 L 8 6" />
      )}
      {optional ? (
        <circle cx={21} cy={0} r={4} fill="var(--canvas, #f5f7f8)" />
      ) : (
        <path d="M 20 -6 L 20 6" />
      )}
    </g>
  );
}
